// Formatting helpers for consistent UI output (no locale surprises)

function parseInputToDate(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  if (typeof value === 'string') {
    // Handle YYYY-MM-DD safely in local time
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return new Date(value + 'T00:00:00');
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  // Fallback: try constructing Date
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDateDMY(value) {
  const d = parseInputToDate(value);
  if (!d) return '—';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function formatRangeDMY(from, to) {
  return `${formatDateDMY(from)} – ${formatDateDMY(to)}`;
}

export function formatMinutesToHM(totalMinutes) {
  const m = Number(totalMinutes || 0);
  if (!m) return '0m';
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h && rem) return `${h}h ${rem}m`;
  if (h && !rem) return `${h}h`;
  return `${rem}m`;
}

export function formatStatusLabel(status) {
  if (status == null) return '';
  const raw = String(status);
  const s = raw.trim().toLowerCase();
  if (s === 'najavi' || s === 'najava') return 'u najavi';
  return raw;
}

export default { formatDateDMY, formatRangeDMY, formatMinutesToHM, formatStatusLabel };
